import { ReactNode } from 'react';
import { TableHeadNewWrapper, TableRowNew } from './styles';

type TableHeadNewType = {
  children: ReactNode;
};

export const TableHeadNew = ({ children }: TableHeadNewType) => {
  return (
    <TableHeadNewWrapper>
      <TableRowNew>{children}</TableRowNew>
    </TableHeadNewWrapper>
  );
};
